import {SeriesType} from "./SeriesType";

export default class ContestFilteredContentItem {

  constructor(private readonly _startHour: number,
              private readonly _startMinutes: number,
              private readonly _type: SeriesType,
              private readonly _arena: string,
              private readonly _difficulty: string,
              private readonly _startNumber: number,
              private readonly _headNumber: number,
              private readonly _rider: string,
              private readonly _horse: string,
              private readonly _clubName: string) {
  }


  get startHour(): number {
    return this._startHour;
  }

  get startMinutes(): number {
    return this._startMinutes;
  }

  get type(): SeriesType {
    return this._type;
  }

  get arena(): string {
    return this._arena;
  }

  get difficulty(): string {
    return this._difficulty;
  }

  get startNumber(): number {
    return this._startNumber;
  }

  get headNumber(): number {
    return this._headNumber;
  }

  get rider(): string {
    return this._rider;
  }

  get horse(): string {
    return this._horse;
  }

  get clubName(): string {
    return this._clubName;
  }
}
